import { atom, useAtom } from "jotai";
import { useMemo } from "react";

export const stateParams = atom<URLSearchParams>(new URLSearchParams());

/**
 * Drop in interface for URLSearchParams that syncs with Jotai state instead of the URL. Useful for places needing key value state support without messing with the actual URL.
 */
export const useStateParams = () => {
	const [searchParams, setSearchParams] = useAtom(stateParams);
	return useMemo(() => {
		return new Proxy(searchParams, {
			get(target, prop: keyof URLSearchParams) {
				// modify set, append and delete to update the atom as well as setting the current state
				if (prop === "set" || prop === "append" || prop === "delete") {
					// biome-ignore lint/suspicious/noExplicitAny: <any>
					return (...args: any[]) => {
						const newParams = new URLSearchParams(target);
						// biome-ignore lint/suspicious/noExplicitAny: <its ok>
						newParams[prop](...(args as [any, any]));
						setSearchParams(newParams);
					};
				}

				const result = target[prop];

				if (typeof result === "function") {
					return result.bind(target);
				}

				return target[prop];
			},
		});
	}, [searchParams, setSearchParams]);
};
